import { inject, Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

export interface MultiLangText {
  en?: string;
  ar?: string;
  [key: string]: string | undefined;
}

@Pipe({
  name: 'langSelect',
  standalone: true,
})
export class LangSelectPipe implements PipeTransform {
  translateService = inject(TranslateService);

  transform(value: MultiLangText | null | undefined): string {
    if (!value) return '';

    const currentLang = this.translateService.getCurrentLang() as keyof MultiLangText;

    return (value[currentLang] as string) ?? value.ar ?? value.en ?? '';
  }
}
